<header class="pb-3 pt-3 border-bottom border-1 border-light-3 bg-size-cover bg-position-top-center" style="background-image: url(../../../../../assets/img/main-bg2.png);" data-aos="fade-down" data-aos-delay="300">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-md-4 col-lg-2 d-flex flex-fill" *ngFor="let front of getFrontends()">
        <frontend-status-large frontend="{{ front.name }}" status="" class="d-flex flex-fill"></frontend-status-large>
      </div>
    </div>
  </div>
</header>

<header class="pt-1 pb-1 border-bottom border-1 border-light-3 bg-size-cover bg-position-top-center" data-aos="fade-down" data-aos-delay="300">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center flex-nowrap">
      <span class="text-dark-1 fs-5">{{ 'common.user_info.space' | translate }}:&nbsp;{{ session?.space }} / {{ 'common.user_info.user' | translate }}:&nbsp;{{ session?.firstName }}&nbsp;{{ session?.lastName }}</span>
      <span class="text-dark-1 fs-5">{{ 'common.user_info.date' | translate }}:&nbsp;{{ getCurrentDateTime() }}</span>
    </div>
    </div>
 </header>

<div class="pb-12" data-aos="fade-down" data-aos-delay="350">
  <ng-content></ng-content>
</div>
